"use client";

import { sanitiseTerms } from "@/utils/product/sanitiseTerms";
import Accordion from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/Accordion";
import { useState } from "react";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
export const PRODUCT_RETURNS_ACCORDION_INSTANCE_NAME = "product-returns";

type Props = {
  terms: string;
  open?: boolean;
};

export function ProductReturnsAccordionUI({ terms, open }: Props) {
  const productReturnsLabel: string | JSX.Element =
    "Returns and exchange policy";
  const [isOpen, setIsOpen] = useState(open);
  const sanitisedTerms = sanitiseTerms(terms);

  return (
    <ProductAccordionWithMonetateEvents name="Returns" open={isOpen}>
      <Accordion
        id="ratings-reviews-section"
        data-testid="accordion:returns"
        label={productReturnsLabel}
        animated={true}
        instanceName={PRODUCT_RETURNS_ACCORDION_INSTANCE_NAME}
        responsive
        open={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: sanitisedTerms }}></div>
      </Accordion>
    </ProductAccordionWithMonetateEvents>
  );
}
